import React from 'react';
import LegalDoc from './LegalDoc';
import content from './ACCEPTABLE_USE_POLICY.md?raw';

const AcceptableUsePolicy = () => <LegalDoc content={content} />;

export default AcceptableUsePolicy;
